import {
  SPREADSHEET_ADD_FILTER_ITEM, SPREADSHEET_FETCH_DATA_ERROR, SPREADSHEET_FETCH_DATA_STARTED,
  SPREADSHEET_FETCH_DATA_SUCCESS, SPREADSHEET_RESET_STATE_AND_REFETCH_DATA,
} from './spreadsheetData.actionTypes';
import {
  type PerSpreadsheetVersionsData, type SpreadsheetDataData,
} from './spreadsheetData.state';

export function spreadsheetFetchSpreadsheetDataStarted() {
  return {
    type: SPREADSHEET_FETCH_DATA_STARTED,
  } as const;
}

export function spreadsheetFetchSpreadsheetDataError(error: Error) {
  return {
    type: SPREADSHEET_FETCH_DATA_ERROR,
    payload: {
      error,
    },
  } as const;
}

export function spreadsheetAddFilterItem(spreadsheetId: number, filterHash: string, rowsData: {[key: string]: 1}) {
  return {
    type: SPREADSHEET_ADD_FILTER_ITEM,
    payload: {
      spreadsheetId,
      filterHash,
      rowsData,
    },
  } as const;
}

export function spreadsheetFetchSpreadsheetDataSuccess(
  data: SpreadsheetDataData,
  etag: Uuid,
  versions: PerSpreadsheetVersionsData,
) {
  return {
    type: SPREADSHEET_FETCH_DATA_SUCCESS,
    payload: {
      data,
      etag,
      versions,
    },
  } as const;
}

type SpreadsheetResetStateAndRefetchDataPayload = Readonly<{
  /**
   * Set to true if the spreadsheet data update could have affected the boundary-territories.
   * Boundary-territories are affected if a new row is added or an existing row is updated or row is removed.
   * Boundary tool doesn't need to be reloaded when geocoding is scheduled. Reload will occur after geocoding is finished.
   */
  reloadBTGs: boolean;
}>;

export function spreadsheetResetStateAndRefetchData(payload: SpreadsheetResetStateAndRefetchDataPayload) {
  return {
    type: SPREADSHEET_RESET_STATE_AND_REFETCH_DATA,
    payload,
  } as const;
}
